import {
  CREATE_CONSIGNMENT_ORDER_REFUND,
  DELETE_CONSIGNMENT_ORDER_REFUND,
  GET_CONSIGNMENT_ORDER_REFUND_BY_CONSIGNMENT_ORDER_ID,
  GET_CONSIGNMENT_ORDER_REFUND_BY_ID,
  UPDATE_CONSIGNMENT_ORDER_REFUND,
} from '../types';
import { get, post, put, remove } from './Action';

const basePath = '/consignment-order-refund';

export const getConsignmentOrderRefundByOrderId =
  (orderId) => async (dispatch) => {
    return await dispatch(
      get(
        `${basePath}/${orderId}/refund`,
        getConsignmentOrderRefundByConsigmentOrderIdDS
      )
    );
  };

export const createConsignmentOrderRefund = (data) => async (dispatch) => {
  return await dispatch(
    post(`${basePath}/create`, data, createConsignmentOrderRefundDS)
  );
};

export const getConsignmentOrderRefundById = (id) => async (dispatch) => {
  return await dispatch(
    get(`${basePath}/${id}`, getConsignmentOrderRefundByIdDS)
  );
};

export const updateConsignmentOrderRefund = (id, data) => async (dispatch) => {
  return await dispatch(
    put(`${basePath}/${id}/update`, data, updateConsignmentOrderRefundDS)
  );
};

export const deleteConsignmentOrderRefund = (id) => async (dispatch) => {
  const response = await dispatch(remove(`${basePath}/${id}/delete`));
  dispatch(deleteConsignmentOrderRefundDS(id));
  return response;
};

const getConsignmentOrderRefundByConsigmentOrderIdDS = (refund) => ({
  type: GET_CONSIGNMENT_ORDER_REFUND_BY_CONSIGNMENT_ORDER_ID,
  payload: refund,
});

const createConsignmentOrderRefundDS = (refund) => ({
  type: CREATE_CONSIGNMENT_ORDER_REFUND,
  payload: refund,
});

const getConsignmentOrderRefundByIdDS = (refund) => ({
  type: GET_CONSIGNMENT_ORDER_REFUND_BY_ID,
  payload: refund,
});

const updateConsignmentOrderRefundDS = (refund) => ({
  type: UPDATE_CONSIGNMENT_ORDER_REFUND,
  payload: refund,
});

const deleteConsignmentOrderRefundDS = (refund) => ({
  type: DELETE_CONSIGNMENT_ORDER_REFUND,
  payload: refund,
});
